<template>
  <div class="information--bars--wrapper">
    <div class="navigation">
      <div class="scroll left" @click="scrollRight()"><div class="icon"><DragLeft/></div><div class="instruction">Click/drag</div></div>
      <div class="scroll right" @click="scrollLeft()"><div class="instruction">Click/drag</div><div class="icon"><DragRight/></div></div>
    </div>
    <div class="information--bars" ref="informationBars">
      <div class="information--bars__header" v-if="header.title">
          <div class="content">
            <h2 :style="headerColor">{{header.title}}</h2>
            <div class="text" :style="headerColor" v-html="header.content"/>
            <div class="scroll" @click="scrollLeft()"><div class="instruction">Scroll to view</div><div ref="arrow" class="arrow"><Arrow/></div></div>
          </div>
          <div class="image" v-if="header.image && header.image[0] && header.image[0].imageUrl">
              <img :src="header.image[0].imageUrl" :alt="header.title"/>
          </div>
          <BottomBackground/>
      </div>
      <div :class="{'information--bar__wrapper':true, 'active': activeItem == item, 'deactivating': (deactivating && lastActiveItem == item)}" :style="barColors(item)" v-for="item in informationItems" :key="item.id" @click="toggleInformationBar(item)">
          <InformationBar :informationItem="item" :detailActive="activeItem == item" :deactivating="lastActiveItem == item"/>
      </div>
    </div>
  </div>
</template>

<script>
import InformationBar from './InformationBar'
import BottomBackground from "@/assets/svg/information-bar-header-background.svg"
import Arrow from '@/assets/svg/arrow.svg'
import DragLeft from "@/assets/svg/drag-left.svg"
import DragRight from "../assets/svg/drag-right.svg"

export default {
  name: "InformationBars",
  components: {
      InformationBar,
      BottomBackground,
      Arrow,
      DragLeft,
      DragRight
  },
  props: {
    header: {
      type: Object,
      default: function() {}
    },
    informationItems: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  data() {
    return {
      popupState: false,
      activeItem: {},
      lastActiveItem: {},
      deactivating: false,
      errors: []
    };
  },
  created() {
    window.addEventListener("resize", this.resize);
  },
  destroyed() {
    window.removeEventListener("resize", this.resize);
  },
  mounted() {
    this.$nextTick(() => {
      this.equalizeImagePositions()
    });
    this.arrowColor();
  },
  updated() {
    this.equalizeImagePositions()
    this.scrollToActive()
  },
  methods: {
    resize() {},
    toggleInformationBar: function(item) {
        if (this.activeItem == item) {
            //Allow time for child animation to complete
            let c = this;
            c.deactivating = true;
            c.lastActiveItem = c.activeItem;
            c.activeItem = {};
            setTimeout(() => {c.deactivating = false; c.lastActiveItem = {}}, 1000)
        } else if (!item.detail) {
          this.activeItem = {};
        } else {
          this.activeItem = item;
        }
    },
    equalizeImagePositions() {
      if (screen.width < 481) {
        return;
      }
      //Loop through header and children to get image position and calculate height
      let imageEls = this.$refs.informationBars.querySelectorAll('.image');
      let maxHeightOffset = 100;
      imageEls && imageEls.forEach((imageEl) => {
        maxHeightOffset = Math.max(imageEl.offsetTop, maxHeightOffset);
      })
      let contentEls = this.$refs.informationBars.querySelectorAll('.content');
      contentEls.forEach((contentEl) => {
        contentEl.style.minHeight = (maxHeightOffset - 25) + "px"
      })
    },
    scrollToActive() {
      let active = this.$refs.informationBars.querySelector('.information--bar__wrapper.active');
      let offset = active ? active.offsetLeft : 0;
      this.$refs.informationBars.scrollTo({left: offset, behavior: 'smooth'});
    },
    scrollLeft() {
      this.$refs.informationBars.scrollLeft = this.$refs.informationBars.scrollLeft + 80;
    },
    scrollRight() {
      this.$refs.informationBars.scrollLeft = this.$refs.informationBars.scrollLeft - 80;
    },
    barColors: function(item) {
      return {
          backgroundColor: item.color && item.color.background ? item.color.background : '#0e1531',
          color: item.color && item.color.foreground ? item.color.foreground : '#ffffff'
        }
    },
    headerColor() {
      return {
        color: this.header.color && this.header.color.foreground ? this.header.color.foreground : '#ffffff'
      }
    },
    arrowColor() {
      let a = this.$refs.arrow.getElementsByTagName("path");
      for (let p of a) {
        p.style.fill = this.header.color && this.header.color.foreground ? this.header.color.foreground : '#ffffff';
      }
    }
  },
  ready: function() {
    window.addEventListener("resize", this.chartSize);
  },
  beforeDestroy: function() {
    window.removeEventListener("resize", this.chartSize);
  }
};
</script>


<style scoped lang="scss">
.information--bars {
    display: flex;
    flex-wrap: nowrap;
    text-align: left;
    width: 100%;
    height: auto;
    overflow-x: scroll;
    min-height: 200px;

    img {
        width: 100%;
    }
    
    .information--bars__header {
        width: 40vw;
        flex: 0 0 auto;
        background-color: #0e1531;
        color: #ffffff;
        position: relative;
        .content {
          padding: 25px;
        }
        .image {
          margin-bottom: 25px;
        }
        > svg {
            width: 100%;
            position: absolute;
            bottom: 0;
        }
    }

    .information--bar__wrapper {
        width: 25vw;
        flex: 0 0 auto;
        background-color: #062c62;
        &.active, &.deactivating {
            width: 50vw;
        }
    }
}
.scroll {
  display: flex;
  width: 100%;
  justify-content: flex-end;
  align-items: center;
  .arrow {
    padding-left: 25px;
  }
  .instruction {
    margin-top: -7px;
  }
}

.navigation {
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 5px;
  color: $color-icon;
  fill: $color-icon;
}

@media (max-width: 480px) {
  .information--bars {
    flex-wrap: wrap;
    .information--bars__header, .information--bar__wrapper {
      width: 100%;
    }
    .information--bar__wrapper {
       &.active, &.deactivating {
         width: 100%;
       }
    }
  }
  .arrow {
    transform: rotate(90deg);
  }
  .navigation {
    display: none;
  }
}
  
</style>